import React from "react";
import { BreadCrumb } from "../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../components/breadcrumbs/BreadRoute";
import { Card } from "../components/utils/Card";

export const EventMenu: React.FC = () => {
  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} lastChild={true} />
      </BreadRoute>
      <div className='container h-full max-h-11/12 w-full flex justify-center'>
        <Card
          header='Event.Card.Create.Header'
          paragraph={"Event.Card.Create"}
          link={`/createevent`}
          linkStr={"Navigation.CreateEvent"}
          image='img/5217.jpg'
          canClick={true}
        />
        <Card
          header='Event.Card.Events.Header'
          paragraph={"Event.Card.Events"}
          link={`/events`}
          linkStr={"Navigation.ListEvents"}
          image='img/calendar.png'
          canClick={true}
        />
      </div>
    </div>
  );
};

export default EventMenu;
